export default "__VITE_PUBLIC_ASSET__a0c5314b__"